// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Bq-z","selected":"Cq-z"};